// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-form-conteudo form {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/account/login.less"],"names":[],"mappings":"AAIA;EACI,WAAA;AAHJ","sourcesContent":["// Estilos estruturais da tela de login vivem em wwwroot/css/auth.css,\n// porque o layout precisa deles antes do bundle carregar (evita flash).\n// Este arquivo fica para ajustes finos específicos da página.\n\n.auth-form-conteudo form {\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
